module.exports = __webpack_public_path__ + "static/media/nstan.d20a0d04.mp3";